export default {
  name: "KNDict",
  props: ["source"]
};